import { QueryMainReport, QuerySummarizeMainReport } from "src/entity/main-report/main-report.entity";
import http from "../utils/http-common";

const baseHistoryPath = "/api/report";

export const getMainReport = (query: QueryMainReport) => {
  return http.get(`${baseHistoryPath}/summary`, { params: query });
};
export const getMainReportOverviews = (query: QueryMainReport) => {
  return http.get(`${baseHistoryPath}/overviews`, { params: query });
};
export const getMainReportForCharts = (query: QueryMainReport) => {
  return http.get(`${baseHistoryPath}/charts`, { params: query });
};
export const getSummarizeMainReport = (query: QuerySummarizeMainReport) => {
  return http.get(`${baseHistoryPath}/summarize/company`, { params: query });
};
export const genMainReportExcel = (query: QuerySummarizeMainReport) => {
  return http.get(`${baseHistoryPath}/excel`, { params: query });
};
export const getDistinctYearDropdown = () => {
  return http.get(`${baseHistoryPath}/distinct/years`, {});
};
